import { parse } from '@config/theme';
export const blogNarrowWidth = parse({
  mx: 'auto'
}, "bc54qy8");
export const spacingBottomM = parse({
  mb: {
    _: '40',
    sm: '56',
    md: '80'
  }
});

require("./spacings.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./spacings.ts");